export default "__VITE_ASSET__284ad6fe__"